// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1da5X","content":"LoadingAlert_content__3wUDi"};